// Copyright (c) Docugami, Inc. All rights reserved.

import { useState } from 'react';
import { Icon, IContextualMenuItem } from "@fluentui/react";
import { primaryTheme } from './AppStyles';
import { ModalViewer } from '../utils/ModalViewer';
import { useDgIcons, dgIconNames } from '../../../hooks/dgIcons';
import { DgIconButton } from '../utils/DgIconButton';
import { MainMenu, MenuItem } from './MainMenu';
import { NavigationType, useNavigationService } from '../../../hooks/navigationService';
import { useDgAuth } from 'hooks/DgAuthentication';
import { AutomationId } from 'utils/Automation';

export const UserProfile = (): JSX.Element => {
    const [modalShowing, setModalShowing] = useState(false);
    const [legalEase, setLegalEase] = useState(<div />);
    const { isAuthenticated, isOrganizationAdmin } = useDgAuth();
    const dgIcons = useDgIcons();
    const navServices = useNavigationService();
    const [menuOpen, setMenuOpen] = useState(false);

    function modalDismissed(): void {
        setModalShowing(false);
        setLegalEase(<div />);
    }

    function getHomeburgerEntries(): MenuItem[] {
        var items: MenuItem[] = [];
        var supportItems: IContextualMenuItem[] = [];
        var helpItems: IContextualMenuItem[] = [];

        const logoutIcon = dgIcons.icon(dgIconNames.Logout, '', 18, 22, primaryTheme.palette.black, '');
        const manageIcon = dgIcons.icon(dgIconNames.Manage, '', 18, 25, primaryTheme.palette.black, '');
        const developerIcon = dgIcons.icon(dgIconNames.DgDeveloperHubIcon, '', 25, 31, primaryTheme.palette.black, '');
        const iconStyle = { root: { fontSize: '20px', fontWeight: '700'}};
        const feedbackIcon = <Icon iconName='Feedback' styles={iconStyle} />;
        const linkIcon = <Icon iconName='Link' styles={iconStyle} />;

        items.push({
            title: 'Manage Account',
            icon: manageIcon,
            listItems: [],
            onClick: () => navServices.navToAccountPage(NavigationType.PushNewPage)
        });

        if (isOrganizationAdmin) {
            items.push({
                title: 'Developer Playground',
                icon: developerIcon,
                listItems: [],
                onClick: () => navServices.navToDeveloperHub()
            });
        }

        supportItems.push(
            {
                key: 'tou',
                text: 'Terms of Use',
                url: 'https://www.docugami.com/terms'
            }
            ,
            {
                key: 'privacy_policy',
                text: 'Privacy Policy',
                url: 'https://www.docugami.com/privacy'
            }
            ,
            {
                key: 'docugami_website',
                text: 'Docugami.com',
                url: 'https://www.docugami.com'
            }
        );

        items.push({
            title: 'Additional Links',
            icon: linkIcon,
            listItems: supportItems
        });

        helpItems.push(
            {
                key: 'help',
                text: 'Help Center',
                url: 'https://help.docugami.com/home'
            }
            ,
            {
                key: 'feedback',
                text: 'Contact Support',
                onClick: () => {
                    const userback = (window as any).Userback;
                    if (!!userback) {
                        userback.open();
                    }
                },
            }

        );

        items.push({
            title: 'Help and Feedback',
            icon: feedbackIcon,
            listItems: helpItems
        });

        if (isAuthenticated) {
            items.push({
                title: 'Log Out',
                icon: logoutIcon,
                listItems: [],
                onClick: () => navServices.logout()
            });
        }

        return items;
    }

    function getMenuIcon(): JSX.Element {
        return <DgIconButton
            iconName={dgIconNames.DgProfile}
            height={27}
            width={22}
            color={primaryTheme.palette.white}
            onClick={() => setMenuOpen(v => !v)}
            shadow={''} />
    }

    function getMenu(): JSX.Element {
        return (
            <div>
                <div key="menu_icon"
                    data-automation-id={AutomationId.NavItemProfile}
                    style={{ paddingRight: "11px" }}>
                    {getMenuIcon()}
                </div>
                <div id="parent-menu" style={{ position: 'absolute', right: '0px', top: '0px' }}>
                    <div style={{ flex: 1, overflowY: 'hidden', float: 'right' }}>
                        <MainMenu
                            offestTop='50px'
                            open={menuOpen}
                            closeCallback={() => setMenuOpen(false)}
                            menuItems={getHomeburgerEntries()} />
                        <ModalViewer
                            title=''
                            hidden={!modalShowing}
                            dismissedCallback={modalDismissed}>
                            {legalEase}
                        </ModalViewer>
                    </div>
                </div>
            </div>)
    }

    return getMenu();
}
